import { create } from 'zustand';

interface SettingsState {
  soundsOn: boolean;
  setSoundsOn: (on: boolean) => void;
  toggleSounds: () => void;
}

const STORAGE_KEY = 'durakapp:sound';

function readInitial(): boolean {
  if (typeof window === 'undefined') return true;
  return window.localStorage.getItem(STORAGE_KEY) !== 'off';
}

function persist(on: boolean): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, on ? 'on' : 'off');
}

export const useSettings = create<SettingsState>((set, get) => ({
  soundsOn: readInitial(),
  setSoundsOn: (on) => {
    persist(on);
    set({ soundsOn: on });
  },
  toggleSounds: () => {
    const on = !get().soundsOn;
    persist(on);
    set({ soundsOn: on });
  },
}));
